/**
 *		SET MENU/SEARCH TOP
 *		- Sets the top of `.site-search` and `.site-menu` dynamically in case there is a Sitewide Alert visible, and changes depending on its height
 */
function setMenuSearchTop() {
    let headerBottom = document.querySelector(".site-header").getBoundingClientRect().bottom;

    let siteSearch = document.querySelector(".site-search");
    siteSearch.style.top = (headerBottom + 4) + 'px';
    siteSearch.style.height = "calc(100vh - " + (headerBottom + 4) + "px)";

    let siteMenu = document.querySelector(".site-header .site-menu");
    siteMenu.style.top = (headerBottom + 4) + 'px';
    siteMenu.style.height = "calc(100vh - " + (headerBottom + 4) + "px)";
}
setMenuSearchTop();

/**
 *      SET CHILD MENUS LEFT POSITION ON DESKTOP
 *      -
 */
function setChildMenusLeft() {
    let hasChildrenMenu = document.querySelectorAll('.site-menu > ul > li.has-children');
    for (let index = 0; index < hasChildrenMenu.length; index++) {
        let childMenu = hasChildrenMenu[index].querySelector(":scope .child-menu");
        if (window.widthREMs >= window.maxWidthContent) {
            childMenu.style.left = "-" + (((hasChildrenMenu[index].getBoundingClientRect().left / parseFloat(window.htmlStyles.fontSize)) - ((window.widthREMs - window.maxWidthContent) / 2)) - window.paddingContent) + "rem";
        } else
        if (window.widthREMs >= breakpointToDesktopNav) {
            childMenu.style.left = "-" + (hasChildrenMenu[index].getBoundingClientRect().left - (window.paddingContent * parseFloat(window.htmlStyles.fontSize))) + "px";
            childMenu.style.maxWidth = (document.body.clientWidth - ((window.paddingContent * parseFloat(window.htmlStyles.fontSize)) * 2)) + "px";
        }
    }
}
setChildMenusLeft()

/**
 *		TOGGLE SEARCH
 *		- Toggle site search on mobile resolutions (lower than breakpointToDesktopNav)
 */
function toggleSearch(event) {
    if (dragging) return;

	var target = event.target.closest(".toggle.nav-search");
	if (target) {
		event.preventDefault();
    event.stopPropagation();

		document.body.classList.toggle("site-search-on");
		document.querySelector(".site-search").classList.toggle("on");

		if (document.querySelector(".site-search").classList.contains("on")) {
				document.querySelector(".site-search input[type='search']").focus();
		}

		// Hide nav
		document.querySelector(".toggle.menu").classList.remove("on");
		document.querySelector(".site-header .site-menu").classList.remove("on");
	}
}

/**
 *		TOGGLE MENU
 *		- Toggle main navigation on mobile resolutions (lower than breakpointToDesktopNav)
 */
function toggleMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".toggle.menu");
	if (target) {
		event.preventDefault();
		event.stopPropagation();

        target.classList.toggle("on");
        document.querySelector(".site-header .site-menu").classList.toggle("on");

        // Hide site search
        document.body.classList.remove("site-search-on");
        document.querySelector(".site-search").classList.remove("on");
	}
}

/**
 *		TOGGLE CHILD MENUS
 *		- Toggle child navigation on mobile resolutions (lower than breakpointToDesktopNav)
 */
function toggleChildMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".toggle.child");
	if (target) {
		event.preventDefault();
		event.stopPropagation();

		target.parentNode.classList.toggle("on");
		var siblingMenu = target.nextElementSibling;
		if (window.getComputedStyle(siblingMenu).display == "none") {
			siblingMenu.style.display = "block";
		} else {
			siblingMenu.style.display = "none";
		}
	}
}

/**
 *		TOGGLE DESKTOP CHILD MENUS
 *		- Prevent link click on Enter keydown
 *		- Open child menu on first touch or Enter keyup, follow link only if child menu is open
 */
function toggleDesktopChildMenu(event) {
	if (dragging) return;

	if (widthREMs >= breakpointToDesktopNav) {
		var target = event.target.closest(".site-menu ul li.has-children > a");
		if (target && event.type == "keydown" && event.key == "Enter") {
			event.preventDefault();
		} else
		if (target && (event.type == "touchend" || (event.type == "keyup" && event.key == "Enter"))) {
			event.stopPropagation();

			// Prevent default on anchor tag on first touch or Enter key
			if (!target.hasAttribute("data-is-open") || target.getAttribute("data-is-open") == "false") {
				event.preventDefault();

				// Hide other child navs, but not if they're an ancestor
				var menusWithChildren = document.querySelectorAll(".site-menu ul li.has-children");
				for (var i = 0; i < menusWithChildren.length; i++) {
					if (!menusWithChildren[i].contains(target)) {
						menusWithChildren[i].classList.remove("on");
						menusWithChildren[i].querySelector(".child-menu").style.display = "none";
						menusWithChildren[i].querySelector(".site-menu ul li.has-children > a").setAttribute("data-is-open", false);
					}
				}

				// Display child navigation on first touch or Enter key
				target.setAttribute("data-is-open", true);
				target.parentNode.classList.toggle("on");
				target.parentNode.querySelector(".child-menu").style.display = "block";
			} else {
				target.setAttribute("data-is-open", false);
				target.click();
			}
		}
	}
}

/**
 *		TOGGLE FOOTER CHILD MENUS
 *		- Toggle child navigation on mobile resolutions
 */
 function toggleFooterChildMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".toggle.child-links");
	if (target) {
		event.preventDefault();
		event.stopPropagation();

		target.parentNode.classList.toggle("on");
		target.parentNode.nextElementSibling.classList.toggle("on");
	}
}

document.addEventListener("DOMContentLoaded", function () {
	/**
	 *		HEADER / NAV
	 *		- Toggle navigation by click/touch on mobile
	 *		- Toggle navigation by mouse enter/leave on desktop
	 */

    window.addEventListener("orientationchange", setMenuSearchTop);
    window.addEventListener("resize", setMenuSearchTop);
    window.addEventListener("scroll", setMenuSearchTop);

    window.addEventListener("orientationchange", setChildMenusLeft);
    window.addEventListener("resize", setChildMenusLeft);

    // Mobile: Site search
    document.addEventListener("click", toggleSearch);
    document.addEventListener("touchend", toggleSearch);

	// Mobile: Main navigation
	document.addEventListener("click", toggleMenu);
	document.addEventListener("touchend", toggleMenu);

	// Mobile: Child navigation
	document.addEventListener("click", toggleChildMenu);
    document.addEventListener("touchend", toggleChildMenu);

    // Mobile: Footer navigation
	document.addEventListener("click", toggleFooterChildMenu);
	document.addEventListener("touchend", toggleFooterChildMenu);

	// Desktop: Close all open child menus on touchend
	document.addEventListener("touchend", function (event) {
		if (widthREMs >= breakpointToDesktopNav) {
			var target = event.target.closest(".site-menu ul li.has-children a");
			// If target is direct child of li.has-children, then follow link
			if (target && !target.parentNode.classList.contains("has-children")) {
			} else
			// Otherwise, stopPropagation and close all menus
			if (!target) {
				event.stopPropagation();
				var linksInMenusWithChildren = document.querySelectorAll(".site-menu ul li.has-children > a");
				for (var i = 0; i < linksInMenusWithChildren.length; i++) {
					linksInMenusWithChildren[i].setAttribute("data-is-open", false);
					linksInMenusWithChildren[i].parentNode.classList.remove("on");
					linksInMenusWithChildren[i].parentNode.querySelector(".child-menu").style.display = "none";
				}
			}
		}
	});

	// Desktop: Open child menu on first touch or Enter keyup, follow link only if child menu is open
	document.addEventListener("touchend", toggleDesktopChildMenu);
	document.addEventListener("keydown", toggleDesktopChildMenu);
	document.addEventListener("keyup", toggleDesktopChildMenu);

	// Desktop: Display child menu when mouse enters, and hide when mouse leaves
	var menusWithChildren = document.querySelectorAll(".site-menu ul li.has-children");
	for (var i = 0; i < menusWithChildren.length; i++) {
		// Show on enter
		menusWithChildren[i].addEventListener("mouseenter", function (event) {
			if (window.widthREMs >= breakpointToDesktopNav) {
				event.target.classList.add("on");
				event.target.querySelector(".child-menu").style.display = "block";
			}
		});
		// Hide on leave
		menusWithChildren[i].addEventListener("mouseleave", function (event) {
			if (widthREMs >= breakpointToDesktopNav) {
				event.target.classList.remove("on");
				event.target.querySelector(".child-menu").style.display = "none";
			}
		});
	}
});